document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  const isMoto = params.get('motorcycle') === 'true' || params.get('moto') === 'true';
  if (!isMoto) return;

  // Delay to ensure dynamic sections (like sliders) are rendered
  setTimeout(() => {
    const cards = document.querySelectorAll('.product-card__image--secondary[data-moto-rollover]');
    cards.forEach((el) => {
      const motoSrc = el.dataset.motoRollover;
      if (!motoSrc) return;

      const img = el.querySelector('img');
      if (img) {
        img.src = motoSrc;
        img.srcset = `${motoSrc} 900w`;
        el.style.backgroundImage = `url('${motoSrc}')`;
      } else {
        const newImg = document.createElement('img');
        newImg.src = motoSrc;
        newImg.width = 900;
        newImg.height = 900;
        newImg.loading = 'lazy';
        newImg.className = 'w-full h-full object-cover';
        el.appendChild(newImg);
        el.style.backgroundImage = `url('${motoSrc}')`;
      }
    });
  }, 400);
});
